import { render, staticRenderFns } from "./VerificationDialog.vue?vue&type=template&id=f6ca195e&scoped=true&"
import script from "./VerificationDialog.vue?vue&type=script&lang=js&"
export * from "./VerificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDialog.vue?vue&type=style&index=0&id=f6ca195e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ca195e",
  null
  
)

export default component.exports